module.exports = __webpack_public_path__ + "static/img/samuel-sianipar-scUBcasSvbE-unsplash_thumb.904ca2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/samuel-sianipar-scUBcasSvbE-unsplash_thumb.png
// module id = ejWT
// module chunks = 4